import SortOrder from '@/constants/SortOrder';

const DefaultCompanyFilter = {
  searchValue: '',
  order: SortOrder.ASC,
  orderBy: '',
};

export default DefaultCompanyFilter;
